import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';
import { gmiRequest } from 'actions/request';
import { getSessionId } from 'selectors/reservationSelectors';

/**
 * @desc Pass in session_id and record payment transaction for that session
 * @param {Object} data { endpoint }
 * @returns {Promise}
 * @memberof services.gma.reservations
 * @example
 * const data = {
 *     session_id: "5J2LQA5MRFTC1"
 * };
 * services.gma.reservations.recordPaymentTransaction(data);
 * // dispatched results stored in `state.gmi.gma.reservation.payment`
 */
export const recordPaymentTransaction = () => (dispatch, getState) => {
  const state = getState();
  const sessionId = getSessionId(state);

  return dispatch(
    gmiRequest({
      action: actions.request({
        data: {
          session_id: sessionId,
        },
        service: services.gma.reservations.recordPaymentTransaction,
      }),
      loadingOverlay: true,
      onComplete: (response) => {
        if (response.messages?.length > 0) {
          // as per the requirement,  should ignore displaying error message for this endpoint if any error occurs.
          // possibly simple solution would be clear the action message which will clear the service error messages
          // note: error message will still be located in _analytics.errors which will be helpful for analytics if they are tracking
          dispatch(actions.cleanMessages());
        }
        return response;
      },
    })
  );
};
